import { Typography, List, ListItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { CollapsibleSection } from '@eng-mono/atlassian/jira/mojira-bugtracker/frontend-feature-issue-list-collapsible-section';
import {
  JsmIssueBase,
  IssueLink,
} from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list-fe';

interface IssueLinksCollapseProps {
  issue: JsmIssueBase;
  expanded: boolean;
  toggleSection: () => void;
}

export function IssueLinksCollapse({
  issue,
  expanded,
  toggleSection,
}: IssueLinksCollapseProps) {
  const navigate = useNavigate();
  const issueLinks = issue?.fields?.issuelinks || ([] as IssueLink[]);

  const groupedLinks: { [relation: string]: JsmIssueBase[] } = {};

  issueLinks.forEach((link) => {
    const linkType = link.type;
    let linkedIssue = null;
    let relation = '';

    if (link.outwardIssue) {
      linkedIssue = link.outwardIssue;
      relation = linkType.outward;
    } else if (link.inwardIssue) {
      linkedIssue = link.inwardIssue;
      relation = linkType.inward;
    }

    if (linkedIssue) {
      if (!groupedLinks[relation]) {
        groupedLinks[relation] = [];
      }
      groupedLinks[relation].push(linkedIssue);
    }
  });

  return (
    <CollapsibleSection
      title="Issue Links"
      expanded={expanded}
      setExpanded={toggleSection}
    >
      {Object.keys(groupedLinks).map((relation) => (
        <div key={relation} style={{ marginBottom: '16px' }}>
          <Typography variant="h6" gutterBottom>
            {relation}
          </Typography>
          <List dense>
            {groupedLinks[relation].map((linkedIssue) => {
              const projectKey = linkedIssue.key.split('-')[0];

              return (
                <ListItem
                  key={linkedIssue.id}
                  style={{ display: 'block', padding: '4px 0' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={linkedIssue.fields.issuetype.iconUrl}
                      alt={`${linkedIssue.fields.issuetype.name} icon`}
                      style={{
                        width: '20px',
                        height: '20px',
                        marginRight: '8px',
                      }}
                    />
                    <Typography variant="body1" style={{ cursor: 'pointer' }}>
                      <a
                        href={`/browse/${projectKey}/issues/${linkedIssue.key}`}
                        onClick={() => {
                          navigate(
                            `/browse/${projectKey}/issues/${linkedIssue.key}`
                          );
                        }}
                      >
                        <strong>{linkedIssue.key}</strong>:{' '}
                        {linkedIssue.fields.summary} (
                        {linkedIssue.fields.status.name})
                      </a>
                    </Typography>
                  </div>
                </ListItem>
              );
            })}
          </List>
        </div>
      ))}
    </CollapsibleSection>
  );
}
